import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.map.js";
export default {
  name: 'd2-table-actions',
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var render = h("span", [this.actions.map(function (action) {
      var attrsDefault = {
        plain: true
      };

      var attrs = _this._.omit(action, ['action']);

      var button = h("d2-button", {
        "attrs": _objectSpread({}, Object.assign({}, attrsDefault, attrs)),
        "class": "is-thin is-margin-bottom",
        "on": {
          "click": function click() {
            return _this.onAction(action);
          }
        }
      });
      return button;
    })]);
    return render;
  },
  props: {
    actions: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    }
  },
  methods: {
    onAction: function onAction(action) {
      var callback = action.action || function () {};

      if (action.confirm) {
        this.$confirm(action.confirm, 'info', {
          confirmButtonText: 'submit',
          cancelButtonText: 'cancel'
        }).then(callback).catch(function () {});
      } else {
        callback();
      }
    }
  }
};